const {h, render, Component} = require('preact');
const ArticleContent = require('./article_content')
const {route} = require('preact-router');

class HiddenArticle extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(){
    this.props.handleNeedHelpFromSearchResults(this.props.article)
  }

  handleTopicSelection(type, index){
    route(`/faq#faqs:${type}-${index}`)
  }

  render() {
    if(this.props.categories  && this.props.article && this.props.handleNeedHelpFromSearchResults) {
      return (
        <div>
          <article id="trending-topics-content" class="tab-contents">
              <section id="trending-topic-section" class="tab-content active">
                <aside class="topics-side-nav">
                  <ul id="trending-topics-secondary-nav" class="unstyled trending-topics-nav">
                      {this.props.categories.map((item,i) =>
                      <li onClick={(e) => {
                      e.preventDefault()
                      this.handleTopicSelection('category',item.categoryId)}} key={item.categoryId}> <a href="#" data-bhw={"web2018_faq_trending_topic_category_"+item.categoryId}>{item.title}</a> </li>)}
                  </ul>
                </aside>
                <div class="trending-topics-article-contents">
                  <ArticleContent onGuestHelp={this.props.onGuestHelp} showGuestHelp={this.props.showGuestHelp} article={this.props.article} handleNeedHelpFromSearchResults={this.props.handleNeedHelpFromSearchResults}/> 
                </div>
              </section>
            </article>
        </div>
      )
  }
  }
}

module.exports = HiddenArticle
